module.exports = __webpack_public_path__ + "img/3.7f2601d8.png";